/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Edit.vue?vue&type=template&id=24d11126&scoped=true&"
import script from "./Edit.vue?vue&type=script&setup=true&lang=js&"
export * from "./Edit.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Edit.vue?vue&type=style&index=0&id=24d11126&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d11126",
  null
  
)

export default component.exports